import type { IMosaicTocExpanded, ITocActionLoadEntries } from "./interface";

/**
 * Adds newly loaded ToC entries that are not already present in state.
 *
 * @param state - The current expanded ToC state.
 * @param action - The action containing the loaded entries and timestamp.
 * @returns The updated ToC state with any missing entries appended and sorted.
 */
export const toc_addNewTocEntries = (
  state: IMosaicTocExpanded,
  action: ITocActionLoadEntries,
): IMosaicTocExpanded => {
  const newState: IMosaicTocExpanded = { ...state };
  const existingIds = newState.tocItems.map((item) => item.id);

  newState.tocItems = [
    ...newState.tocItems,
    ...action.entries.filter((item) => !existingIds.includes(item.id)),
  ].sort(
    (first, second) =>
      (first.tocOrder ??
        // istanbul ignore next -- reducer items should already carry a persisted order value.
        0) -
      (second.tocOrder ??
        // istanbul ignore next -- reducer items should already carry a persisted order value.
        0),
  );
  newState.saving = false;
  newState.lastMinorVersionSavedAt = action.loadTimeStamp;
  newState.sendUpdate = true;

  return newState;
};
